<template>
    <div> 
        <div class="previewImage" id="imageFull">
            <div @click="previewFunctions('imageHide')" id="imageHide" class="imageHide"></div>
            <div class="lg-toolbar lg-group">
                <el-tooltip class="item" effect="dark" content="Close" placement="bottom">
                    <span class="lg-close lg-icon icon icon-close" @click="previewFunctions('imageHide')" id="imageHide"></span>
                </el-tooltip>
                <span v-if="!file_preview.content_type.startsWith('image/svg+xml')">
                    <el-tooltip class="item" effect="dark" content="Download" placement="bottom">    
                        <a class="lg-download lg-icon icon icon-download" :href="file_preview.url" download id="downloadFile" v-if="file_preview.content_type.startsWith('image') || file_preview.content_type.startsWith('audio') || file_preview.content_type.startsWith('video')"></a>
                    </el-tooltip>
                    <span v-if="isFullScreen == false" @click="previewFunctions('imageFullScreen')" id="imageFullScreen" v-show="file_preview.content_type.startsWith('image') || file_preview.content_type.startsWith('audio') || file_preview.content_type.startsWith('video')">
                        <el-tooltip class="item" effect="dark" content="Full Screen" placement="bottom">    
                            <span class="lg-fullscreen lg-icon icon icon-fullscreen"></span>
                        </el-tooltip>   
                    </span>
                    <span v-else @click="previewFunctions('exitFullScreen')" id="exitFullScreen" v-show="file_preview.content_type.startsWith('image') || file_preview.content_type.startsWith('audio') || file_preview.content_type.startsWith('video')">
                        <el-tooltip class="item" effect="dark" content="Full Screen" placement="bottom">    
                            <span class="lg-fullscreen lg-icon icon icon-fullscreen-exit"></span>
                        </el-tooltip>   
                    </span> 
                    <el-tooltip class="item" effect="dark" content="Rotate Left" placement="bottom">
                        <span id="rotateLeft" class="lg-icon icon icon-rotate-left" @click="previewFunctions('rotateLeft')" v-if="file_preview.content_type.startsWith('image')"></span>
                    </el-tooltip>    
                    <el-tooltip class="item" effect="dark" content="Rotate Right" placement="bottom">
                        <span id="rotateRight" class="lg-icon icon icon-rotate-right" @click="previewFunctions('rotateRight')" v-if="file_preview.content_type.startsWith('image')"></span>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="Zoom Out" placement="bottom">    
                        <span id="zoomOut" class="lg-icon icon icon-magnify-minus-outline zoomOut" v-if="file_preview.content_type.startsWith('image') && scale == 1"></span>
                        <span id="zoomOut" class="lg-icon icon icon-magnify-minus-outline" @click="previewFunctions('zoomOut')" v-if="file_preview.content_type.startsWith('image') && scale>1"></span>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="Zoom In" placement="bottom">    
                        <span id="zoomIn" class="lg-icon icon icon-magnify-plus-outline" @click="previewFunctions('zoomIn')" v-if="file_preview.content_type.startsWith('image')"></span>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="Zoom Reset" placement="bottom">    
                        <span id="zoomReset" class="lg-icon icon icon-image-filter-none" style="font-size: 18px !important;line-height: 36px;" @click="previewFunctions('zoomReset')" v-if="file_preview.content_type.startsWith('image')"></span>
                    </el-tooltip>
                </span>      
                <div>  
                    <span class="font-weight-bold m-4 text-white d-flex" style="font-size:17px;align-items:center">{{file_preview.name}}</span>
                </div>
            </div>
            <div class="image-wrapper" v-if="load_media == true">
                <hollow-dots-spinner
                :animation-duration="1000"
                :dot-size="17"
                :dots-num="3"
                color="#fff"/>
            </div>    
            <div class="image-wrapper" v-else-if="(file_preview.content_type.startsWith('text') && !file_preview.content_type.startsWith('text/html')) || file_preview.content_type.startsWith('application') || file_preview.content_type.startsWith('image/svg+xml')">
                <div class="text-white noPreview">
                    No Preview for this file
                    <!-- <div class="d-block mt-3" @click="previewFunctions('downloadFile',file_preview['_id']['$oid'])" id="downloadFile">
                        <button type="button" class="btn btn-secondary btn-smm" style="box-shadow: none;">Download</button>
                    </div>     -->
                </div>    
            </div>   
            <div v-else-if="file_preview.content_type.startsWith('text/html')">
                <RawHTMLViewer :htmlContent="rawHtml" />
            </div>
            <div v-else-if="file_preview.content_type.startsWith('video/x-flv')">
                <video id="videoElement"></video>
            </div>
            <div class="image-wrapper" @click.prevent="handleClick()" @click="previewFunctions('zoomIn')" :style="imgTransform" :class="{transition: imgTransitionStatus}" v-else-if="file_preview.content_type.startsWith('image')">
                <img :src="image_url" class="imageDisplay" accept="*">
            </div>
            <div class="image-wrapper" v-else-if="file_preview.content_type.startsWith('video')">
                <video width="920" height="520" controls autoplay poster="/static/images/cloud/video-icon.svg" controlsList="nodownload" disablepictureinpicture class="mt-5">
                    <source :src="image_url" type="">
                </video>    
            </div>
            <div class="image-wrapper" v-else-if="file_preview.content_type.startsWith('audio')">
                <img src="/static/images/cloud/audio-icon.svg" class="ml-12" style="width:20rem;">
                <audio controls controlsList="nodownload" class="mt-4 d-block" autoplay>
                    <source :src="image_url" type="">
                </audio>    
            </div>
            <!-- <div class="image-wrapper" v-else-if="file_preview.content_type.startsWith('application/pdf')">
                <vue-pdf-viewer height="500px" :url="image_url"></vue-pdf-viewer>
            </div>     -->
        </div>      
    </div>    
</template>
<script>
import {
    EventBus
} from './eventBus/nav-bar-event.js';
const RawHTMLViewer = () => import('./RawHTMLViewer.vue')

export default {
    props:['file_preview'],
    data() {
        return{
            image_url:'',
            scale:1,
            rotateImage: 0,
            imgIndex: 0,
            imgTransitionStatus: true,
            top: 0,
            left: 0,
            lastX: 0,
            lastY: 0,
            load_media: false,
            isFullScreen: false,
            hideFunctions: false,
            rawHtml: ''
        }
    },
    components: {
        RawHTMLViewer
    },
    methods: {
        async previewFunctions(obj){
            if(obj == 'zoomReset'){
                this.scale = 1
            }
            else if(obj == 'zoomIn'){
                this.scale += 0.25
            }
            else if(obj == 'zoomOut'){
                if (this.scale !== 0) {
                    this.scale -= 0.25
                }
            }
            else if(obj == 'rotateRight'){
                this.scale = 1
                this.rotateImage += 90
            }
            else if(obj == 'rotateLeft'){
                this.scale = 1
                this.rotateImage -= 90
            }
            else if(obj == 'imageFullScreen'){
                this.isFullScreen = true;
                var imgFull = document.getElementById("imageFull");
                if (imgFull.requestFullscreen) {
                    imgFull.requestFullscreen();
                }
                else if (imgFull.msRequestFullscreen) {
                    imgFull.msRequestFullscreen();               
                }
                else if (imgFull.mozRequestFullScreen) {
                    imgFull.mozRequestFullScreen();      
                }
                else if (imgFull.webkitRequestFullscreen) {
                    imgFull.webkitRequestFullscreen();       
                } else {
                    console.log("Fullscreen API is not supported");
                } 
            }
            else if(obj == 'exitFullScreen'){
                this.isFullScreen = false;
                var imgFull = document.getElementById("imageFull");
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                }
            }
            else if(obj == 'imageHide'){
                this.isFullScreen = false;
                EventBus.$emit('ZindexChangeEnd')
                this.$emit("hidePreview")
            }
        },
        handleClick(e){
            
        },
        FetchPlainTextHTML(){
            var decoded = ''
            // fetch('https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/test.html')
            // fetch('./index.html')
            fetch(this.file_preview.url)
            .then((res) => {
                if (!res.ok) {
                throw new Error('Network response was not ok');
                }
                return res.blob();
            })
            .then(blob => {
                const fr = new FileReader();
                let vm = this;
                fr.readAsDataURL(blob)
                fr.onload = function(){
                    const res = fr.result
                    decoded = atob(res.split(',')[1])
                    vm.rawHtml = decoded
                }
                const file = new File([blob], 'html', {type: blob.type})
                console.log(file)
            })
            .catch(error => {
                console.error('Error fetching Blob file:', error);
            });
        }
    },
    mounted() {
        this.image_url = this.file_preview.url;
        if(this.file_preview.content_type == 'text/html'){
            this.FetchPlainTextHTML()
        }
        // if (flvjs.isSupported()) {
        //     var videoElement = document.getElementById('videoElement');
        //     var flvPlayer = flvjs.createPlayer({
        //         type: this.file_preview.content_type,
        //         url: this.image_url
        //     })
        //     flvPlayer.attachMediaElement(videoElement);
        //     flvPlayer.load();
        //     flvPlayer.play();
        // }
    },
    computed: {
        imgTransform: {
            get () {
                return {
                    transform: `translate(-50%, -50%)
                    scale(${this.scale})
                    rotate(${this.rotateImage}deg)`,
                }
            }    
        }
    },
}
</script>

<style>
.closeImage{
    z-index: 9998;
    position: fixed;
    top: 35px;
    right: 36px;
    cursor: pointer;
}
.closeImage i{
    font-size: 42px;
}
.previewImage{
    z-index: 9998;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.70);
    opacity: 1;
    transition: transform .3s ease-in-out,-webkit-transform .3s ease-in-out;
}
.image-wrapper{
    transform: translate(-50%, -50%) scale(1) rotate(-0deg);
    top: calc(50% + 0px);
    left: calc(50% + 0px);
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50% -50%);
    transform: translate(-50% -50%);
    transition: transform .3s ease-in-out,-webkit-transform .3s ease-in-out;
}
.imageDisplay{
    vertical-align: middle;
    position: relative;
    background: #ffff;
    max-width: 80vw;
    max-height: 60vh;
    cursor: move;
}
.img-wrapper.transition {
    transition: transform 0.3s ease-in-out;
}
.imageFunctions{
    user-select: none;
    position: fixed;
    bottom: 30px;
    z-index: 99999;
    left: 50%;
    -webkit-transform: translate(-50%);
    transform: translate(-50%);
}
.imageFunctions span{
    background: rgba(45,45,44,.8);
    border-radius: 50%;
    margin-right: 6px;
    padding: 4px;
}
.imageFunctions i{
    font-size: 25px;
}
.noPreview{
    background-color: #4c494c;
    -webkit-border-radius: 12px;
    border-radius: 12px;
    color: #fff;
    cursor:auto !important;
    margin-bottom: 40px;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 30px;
    padding-right: 30px;
    text-align: center;
    -webkit-box-shadow: 0 10px 12px 5px rgba(0,0,0,0.2) !important;
    box-shadow: 0 10px 12px 5px rgb;
    font-weight: bold;
}
.lg-toolbar{
    z-index: 1082;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    background-color: rgba(0,0,0,.75);
}
.lg-toolbar .lg-icon{
    color: #fff;
    cursor: pointer;
    float: right;
    font-size: 24px;
    height: 57px;
    line-height: 37px;
    padding: 10px 0;
    text-align: center;
    width: 50px;
    text-decoration: none !important;
    outline: medium none;
    -webkit-transition: color 0.2s linear;
    -o-transition: color 0.2s linear;
    transition: color 0.2s linear;
}
.imageHide{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
.zoomOut{
    opacity: 0.6;
}
.previewLogo{
    position: absolute;
    left: 46%;
    display: flex;
    font-size: 20px;
    margin-top: 14px;
}
video {
    background-repeat: no-repeat;
    background-size: 30px 10px;
    overflow: hidden;
}
</style>
